import React__default from 'react';
import Tooltip from '../../components/Tooltip/Tooltip.js';
import AtlasTooltip from '../../components/AtlasTooltip/AtlasTooltip.js';
import Box from '../../components/Box/Box.js';

const IconWithTooltip = ({
  children,
  content,
  position = 'bottom',
  hideArrow = true,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(Tooltip.Provider, null, /*#__PURE__*/React__default.createElement(AtlasTooltip, {
    delay: 0,
    hideArrow: hideArrow,
    content: content,
    position: position
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: 'fit-content'
    }
  }, children)));
};
IconWithTooltip.displayName = "IconWithTooltip";
var IconWithTooltip$1 = IconWithTooltip;

export { IconWithTooltip$1 as default };
